import { StudioTour } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'

/**
 * Creates a mock StudioTour
 * @param overrides - Partial fields to override defaults
 * @returns Complete StudioTour mock
 */
export function createStudioTour(
  overrides: Partial<StudioTour> = {}
): StudioTour {
  return {
    _uid: '81440099-889b-473a-a42d-78d2aa3e1aa9',
    subline:
      'Machen Sie einen virtuellen Rundgang durch ein SUNPOINT Beauty- & Tanning-Studio',
    headline: 'Virtueller Studiorungang',
    component: 'studio-tour',
    placeholderImage: createStoryblokAsset({
      id: 0,
      name: 'placeholder',
      alt: 'Studio Tour Placeholder',
      filename: '',
      src: '',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    _editable:
      '<!--#storyblok#{"name": "studio-tour", "space": "235453", "uid": "81440099-889b-473a-a42d-78d2aa3e1aa9", "id": "418757635"}-->',
    ...overrides,
  }
}
